const o=o=>o.filter((o=>void 0!==o));export{o as filterUndefineds};
